import * as React from "react";

function SvgBBiconsSpisovaZnacka(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <g data-name="Obecn\xE9 ikony">
        <path
          d="M62.63 18.29a20 20 0 00-20.12 19.88c0 .27.07.53.08.8h-.08v123.31h.05v.56a6.79 6.79 0 00.14.67 19.94 19.94 0 0019.93 18l89.91.19a5 5 0 005-5V54.22a5 5 0 00-5-5H100V101.7l-18.66-8.54-18.63 8.54V49.32v-.1h-.11a11 11 0 110-22.09 3.88 3.88 0 00.61-.14 3.9 3.9 0 00.59.14h89.4a4.42 4.42 0 000-8.84H63.83a3.87 3.87 0 00-.59.13 3.87 3.87 0 00-.61-.13zm2.72 17a2.56 2.56 0 100 5.11h76.81a2.56 2.56 0 000-5.11z"
          fillRule="evenodd"
          data-name="Znacka soudniho spisu"
        />
      </g>
    </svg>
  );
}

export default SvgBBiconsSpisovaZnacka;
